import React from "react";

// Material UI
import Container from "react-bootstrap/Container";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListItemButton from "@mui/material/ListItemButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

// Redux
import { selectToken } from "../storeConfig/reducers/loginReducer";
import { useSelector } from "react-redux";

// Router
import { Link } from "react-router-dom";

// React Query
import { useResult, deleteResultByID } from "../services/resultado";
import { useQueryClient } from "@tanstack/react-query";

// Components
import EvolucaoBarra from "../components/MeusResultados/EvolucaoBarra";
import EvolucaoRadar from "../components/MeusResultados/EvolucaoRadar";

const MeusResultados = () => {
	const token = useSelector(selectToken);
	const queryClient = useQueryClient();

	const { isLoading, data } = useResult(token);

	const centerViewPort = {
		margin: "0 auto",
		position: " absolute",
		left: "50%",
		top: "50%",
	};

	const handleRemoveResult = (id) => {
		deleteResultByID(token, id)
			.then((r) => {
				console.log(r);
				queryClient.invalidateQueries(["my-results"]);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	return (
		<>
			{isLoading ? (
				<div
					style={centerViewPort}
					className="d-flex justify-content-center"
				>
					<CircularProgress />
				</div>
			) : (
				<Container>
					<h1 className="m-5">Resultados</h1>

					<Card className="mt-4" variant="contained">
						<div className="d-flex justify-content-center my-2">
							<div className="row col-12 col-sm-10">
								<List
									sx={{
										bgcolor: "background.paper",
									}}
									component="nav"
								>
									{data.length !== 0 ? (
										data.map((it, ind) => {
											let data_resultado = new Date(
												it.data_resultado
											);

											let dataResultado =
												data_resultado.toLocaleDateString(
													"pt-BR"
												);
											let horaResultado =
												data_resultado.toLocaleTimeString(
													"pt-BR"
												);

											return (
												<div key={ind}>
													<ListItem
														button
														divider
														disablePadding
														secondaryAction={
															<ListItemSecondaryAction>
																<ListItemButton
																	onClick={() =>
																		handleRemoveResult(
																			it.id
																		)
																	}
																>
																	<DeleteIcon />
																</ListItemButton>
															</ListItemSecondaryAction>
														}
													>
														<ListItemButton
															role={undefined}
															component={Link}
															to={`resultado/${it.id}`}
														>
															<ListItemText
																primary={
																	it.nome_organizacao ===
																	""
																		? `${dataResultado} ${horaResultado}`
																		: it.nome_organizacao
																}
																secondary={
																	it.nome_organizacao !==
																	""
																		? `${dataResultado} | ${horaResultado}`
																		: ""
																}
															/>
														</ListItemButton>
													</ListItem>
												</div>
											);
										})
									) : (
										<ListItem button divider>
											<ListItemText primary="Nenhum" />
										</ListItem>
									)}
								</List>
							</div>
						</div>
					</Card>

					<h1 className="my-5">Evolução</h1>

					<Card variant="contained">
						<EvolucaoRadar listaResultados={data} />
						<EvolucaoBarra listaResultados={data} />
					</Card>

					<div className="row d-flex justify-content-around mt-5">
						<Button
							className="col-sm-4"
							id="exportar"
							onClick={() => window.print()}
							endIcon={<PictureAsPdfIcon />}
						>
							Exportar como PDF
						</Button> 
					</div>
				</Container>
			)}
		</>
	);
};

export default MeusResultados;
